
import Axios from "../helper/appConfig";

export const getWallet = async (loginUserId) => {

  const payload = {
    "search": [
        {
            "searchfield": "status",
            "searchvalue": "active",
            "criteria": "eq",
            "datatype": "text"
        },
        {
            "searchfield": "_id",
            "searchvalue": loginUserId, // memberID
            "criteria": "eq",
            "datatype": "objectId"
        }
    ],
    "formname": "member",
    "viewname": "memberviews",
    "searchtext": ""
}


  return Axios.post("api/members/filter", payload);
};
